
import React, { useEffect, useState } from 'react';
import { cmsDetailsAction } from '../../../features/webCommonSlice';
import CmsPageShimmer from '../CmsPageShimmer/CmsPageShimmer';

const AboutUs = () => {
    // const [loader, setLoader] = useState(false)
    // const [cmsDetails, setCmsDetails] = useState({});

    // useEffect(() => {
    //     setLoader(true)
    //     cmsDetailsAction({ slug: "about-us" }, (response) => {
    //         if (response?.status === true) {
    //             setCmsDetails(response?.data)
    //         }
    //         setLoader(false)
    //     })();
    // }, [cmsDetailsAction])

    return (
        <>
            <div className='cms_landing_page'>
                <div className='banner'>
                    About Us
                    {/* {cmsDetails?.title} */}
                    {/* {cmsDetails?.updatedAt ? moment(cmsDetails.updatedAt).format("YYYY-MM-DD") : "-"} */}
                </div>
                <div className='container'>
                    {/* {!loader ?
                        <div className='cms_content_text'>
                            <div dangerouslySetInnerHTML={{ __html: cmsDetails.description }}></div>
                        </div>
                        :
                        <>
                            <CmsPageShimmer />
                        </>
                    } */}
                    <div className='cms_content_text'>
                        <p>Welcome to Millionaire11, your ultimate destination for fantasy real-money gaming, proudly operated by MILLIONAIRE11 FANTASY SPORTS PRIVATE LIMITED.</p>
                        <br />
                        <p>At Millionaire11, we are passionate about bringing the thrill of cricket to your fingertips through an immersive fantasy gaming experience. Our platform is designed to offer a safe, engaging, and fair environment, where users can compete in exciting contests, test their skills, and win real rewards. We believe in fostering a community-driven approach, allowing players to share ideas, refine their strategies, and connect with like-minded cricket enthusiasts. With a commitment to transparency, security, and responsible gaming, we ensure that every user enjoys a seamless and trustworthy gaming experience.</p>
                        <br />
                        <p>We are very proud to be a certified member of the Federation of Indian Fantasy Sports (FIFS), reinforcing our dedication to ethical gaming standards and industry best practices. You can view our certification.</p>
                             {/* <a href="https://fifs.in/certificates/crickrts11/" rel="noopener noreferrer" target="_blank">here</a>. */}
                        <br />
                        <p>Join Millionaire11 today and take your love for cricket to the next level!</p>
                        <br />
                        <p>🚀 <strong>Play. Compete. WinBig.</strong></p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AboutUs